<template>
    <div >

        
            <b-input-group>
                <b-input readonly type="text" :value="link"></b-input>
                <b-input-group-append>
                    <copy-to-clipboard :text="link" @copy="copyLink"><b-button variant="outline-secondary" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><i class="fa fa-copy"></i> Copy Link</b-button></copy-to-clipboard>
                </b-input-group-append>
            </b-input-group>
        

    </div>
</template>

<script>
    import CopyToClipboard from 'vue-copy-to-clipboard';
    import Noty from 'noty';

    export default {
        components: {
            CopyToClipboard
        },
        props: [
            'link'
        ],
        methods:{        
            copyLink: function(result){
                if(result){
                    
                    new Noty({
                      text: 'Link Copied to Clipboard',
                      type: 'success',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 1000
                    }).show();
                }
            },
        }
    }
</script>